export interface AssetClass {
  id: number;
  customName: string;
  originalName: string;
  included: boolean;
  canExclude: boolean;
  isCustom: boolean;
  customHighLevelAssetClass: number;
}

export type Returns = Record<number, number>;
export type Volatilities = Record<number, number>;
export type Correlations = Record<number, Record<number, number>>;

export enum ModalType {
  RESET,
  CMACHANGE,
}

export enum CMAType {
  Year2005To2024CMAs,
  Year2020CMAs,
  Year2021CMAs,
  Year2022CMAs,
  Year2023CMAs,
  CustomCMAs,
  Year2024CMAs,
  Year2025CMAs,
  Year2026CMAs,
}
